/**
 * TroiaEmailPage - Página wrapper para variante nativa TROIA
 */

import React from 'react';
import { TroiaEmailLayout } from '../components/TroiaEmailLayout';

interface TroiaEmailPageProps {
  conversationId?: string;
  onSelectConversation: (id: string) => void;
  onClearSelection: () => void;
}

export const TroiaEmailPage: React.FC<TroiaEmailPageProps> = ({
  conversationId,
  onSelectConversation,
  onClearSelection,
}) => {
  return (
    <TroiaEmailLayout
      conversationId={conversationId}
      onSelectConversation={onSelectConversation}
      onClearSelection={onClearSelection}
    />
  );
};

TroiaEmailPage.displayName = 'TroiaEmailPage';
